module.exports = __webpack_public_path__ + "static/media/whatWeOfferProjects.fdc5cc0f.svg";